const URL = `${process.env.REACT_APP_AGI_WEBSITE}/api/priceList`;
export const ENDPOINTS = {
  brands: `${URL}/brands`,
  search: `${URL}/search`
};

export const brands = async () => {
  const res = await fetch(ENDPOINTS.brands, {
    method: 'GET'
  });
  return res.ok ? res.json() : null;
};

export const search = async values => {
  const res = await fetch(ENDPOINTS.search, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(values)
  });
  return res.ok ? res.json() : null;
};
